import CryptoJS from 'crypto-js';

export const encryptId = (id, secretKey) => {
  try {
    const cipherText = CryptoJS.AES.encrypt(JSON.stringify(id), secretKey).toString();
    return encodeURIComponent(cipherText);
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};
